<template>
  <div class="read">
    <div class="pgnnp-header">
      <Paganiniplus />
    </div>
    <div class="mk-container">
      <h1 class="structure-header">
        {{ $t('READ.TITLE') }} | MUZIK AIR
      </h1>
      <ReadBanner />
      <div class="pgnnp-container">
        <Paganiniplus />
      </div>
      <ReadTabs />
    </div>
    <div class="pgnnp-footer">
      <Paganiniplus />
    </div>
  </div>
</template>

<script>
import ReadBanner from '@/components/read/ReadBanner'
import ReadTabs from '@/components/read/ReadTabs'
import Paganiniplus from '@/components/tsp/Paganiniplus'

export default {
  name: 'Read',
  components: {
    Paganiniplus,
    ReadBanner,
    ReadTabs
  },
  props: {},
  data() {
    return {}
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      return `MUZIK AIR | ${this.$t('READ.TITLE')}`
    },
    description() {
      return this.$t('READ.META_DESCRIPTION')
    },
    keywords() {
      return this.$te('READ.META_KEYWORDS')
    },
    cover() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/read.png`
    },
    canonicalURL() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    structuredData() {
      return [{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.description,
        author: {
          '@type': 'Organization',
          sameAs: [
            'https://facebook.com/muzikcom/',
            'https://www.instagram.com/muzikmagazine/',
            'http://line.me/ti/p/@pwr7122w#~',
            'https://www.youtube.com/user/MUZIKmagazine'
          ]
        },
        publisher: {
          '@type': 'Organization',
          sameAs: [
            'https://facebook.com/muzikcom/',
            'https://www.instagram.com/muzikmagazine/',
            'http://line.me/ti/p/@pwr7122w#~',
            'https://www.youtube.com/user/MUZIKmagazine'
          ]
        },
        relatedLink: [
          `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_AIR}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/authors`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      },
      {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        url: `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}`,
        logo: {
          '@type': 'ImageObject',
          'url': this.cover
        }
      }]
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss">
  .structure-header {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    visibility: hidden;
  }
  .pgnnp-header {
    margin-top: 24px;
    // margin-bottom: 0;
  }
  .pgnnp-container {
    margin: 24px auto;
  }
  .pgnnp-footer {
    margin-top: 0;
    margin-bottom: 36px;
  }
</style>
